module.exports = __webpack_public_path__ + "assets/images/pages/kfc/kfc-1.webp?82c1e527";